import { ParamsForOption } from 'common/enum'
import { getApiClient } from './ApiClient'

export const partnerListPromise = () => {
  return getApiClient()
    .get('/partners', { params: ParamsForOption })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const linkUserToPartnerPromise = async function (body) {
  return getApiClient().post('/partner/link', { body }).then(resp => resp.data)
}

export const unlinkUserToPartnerPromise = async function (body) {
  return getApiClient().post('/partner/unlink', { body }).then(resp => resp.data)
}

// The rest of this file is the partner *account* admin (API-1007). `partnerListPromise` above is
// the id+name dropdown feed; this list carries the whole row so the console can edit it.
export const partnerDetailedListPromise = (params) => {
  return getApiClient()
    .get('/partners/accounts', { params })
    .then(resp => resp.data)
}

export const partnerDetailPromise = (id) => {
  return getApiClient()
    .get(`/partners/${id}`)
    .then(resp => resp.data)
}

// The response carries `clientSecret` exactly once. It is absent from every read.
export const partnerCreatePromise = (body) => {
  return getApiClient()
    .post('/partners', { body })
    .then(resp => resp.data)
}

export const partnerUpdatePromise = (id, body) => {
  return getApiClient()
    .put(`/partners/${id}`, { body })
    .then(resp => resp.data)
}

export const partnerRotateSecretPromise = (id, body) => {
  return getApiClient()
    .post(`/partners/${id}/rotate-secret`, { body })
    .then(resp => resp.data)
}
